import { useTranslation } from "react-i18next";
import {
  Button,
  Card,
  Dropdown,
  Form,
  FormInstance,
  Layout,
  MenuProps,
  message,
  Modal,
  Popconfirm,
  Space,
  Switch,
  TableColumnsType,
  TableProps,
  Typography,
} from "antd";
import {
  ChangeEvent,
  FunctionComponent,
  KeyboardEvent,
  useEffect,
  useState,
} from "react";
import { DataType, validateFieldCreate } from "../../constants/data";
import { useNavigate, useSearchParams } from "react-router-dom";
import { routesConfig } from "../../../../../config/routes";
import { formatDateV2 } from "../../../../../utils/converDate";
import { get, isEmpty } from "lodash";
import {
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  LoadingOutlined,
  MoreOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { HelpService } from "../../../../../service/helper.service";
import TableData from "../../../../../components/table-data/TableData";
import {
  addMoocPortfolioValue,
  deleteMoocPortfolioValue,
  downloadPortfolioValueTemplateFile,
  exportExcelMoocPortfolioValue,
  getAllPortfolioValueByName,
  getAllValueByFilter,
  getMoocPortfolioValueById,
  importExcelMoocPortfolioValue,
  updateMoocPortfolioValue,
} from "../../../../../service/category-management/portfolio-value-management";
import { getAllPortfolioByName } from "../../../../../service/category-management/shared-categories-management";
import PageHeader from "../../../../../components/page-header/PageHeader";
import FilterTable from "../filter-table/FilterTable";
import FormFilter from "../filter-group/FormFilter";
import DrawerCustom from "../../../../../components/drawer/Drawer";
import FormCreatePortfolioValue from "../form-create-portfolio-value/FormCreatePortfolioValue";

type CardPortfolioValueProps = {
  title?: string;
  dataPortfolioValue: any;
  dataOptions: any;
  portfolioIdValue: number | string | null;
  setDataPortfolioValue: (value: any) => void;
  setListDataPortfolio: (value: any) => void;
  setDataOptions: (value: any) => void;
};

const CardPortfolioValue: FunctionComponent<CardPortfolioValueProps> = ({
  title,
  dataPortfolioValue,
  dataOptions,
  portfolioIdValue,
  setDataPortfolioValue,
  setListDataPortfolio,
  setDataOptions,
}) => {
  const { t } = useTranslation();
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [statusOrder, setStatusOrder] = useState<string>("");
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("");
  const [searchValue, setSearchValue] = useState<string>("");
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [params, setParams] = useSearchParams();
  const [form] = Form.useForm();
  const [loadingForm, setLoadingForm] = useState<boolean>(false);
  const [dataDetail, setDataDetail] = useState<any>({});
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [isOpenedEdit, setIsOpenedEdit] = useState<boolean>(false);
  const [editId, setEditId] = useState<number>(0);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [isRendering, setIsRendering] = useState<boolean>(false);
  const [listPortfolioValueHasParentID, setListPortfolioValueHasParentID] =
    useState<any>([]);

  const helpService = new HelpService();
  const navigate = useNavigate();

  const [filterData, setFilterData] = useState<any>({
    keyword: null,
    status: null,
    portfolioId: null,
    createdDateFrom: null,
    createdDateTo: null,
  });

  const portfolioOptions: MenuProps["items"] = [
    {
      key: "1",
      label: t("Sửa giá trị", "Sửa giá trị"),
      icon: <EditOutlined />,
    },
    {
      key: "2",
      label: t("Xóa giá trị", "Xóa giá trị"),
      icon: <DeleteOutlined />,
      className: "dropdown-delete",
      danger: true,
    },
  ];

  const dataColumns: TableColumnsType<DataType> = [
    {
      title: t("STT", "STT"),
      dataIndex: "stt",
      key: "stt",
      width: 5,
      render: (_: any, record, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    {
      title: t("Tên giá trị", "Tên giá trị"),
      dataIndex: "name",
      key: "name",
      sorter: true,
      width: 20,
      render: (_: any, record) => {
        return (
          <div className="table-portfolio cursor-pointer">
            <div>
              <a
                className="portfolio-name"
                onClick={() =>
                  navigate(
                    `${routesConfig.portfolioValueManagementDetail}/${record?.id}`,
                    {
                      state: {
                        mode: "view",
                        record,
                        name: record.name,
                        idEdit: record?.id,
                      },
                    }
                  )
                }
              >
                {record.name}
              </a>
            </div>
          </div>
        );
      },
    },
    {
      title: t("Mã giá trị", "Mã giá trị"),
      dataIndex: "code",
      key: "code",
      width: 10,
    },
    {
      title: t("Giá trị cha", "Giá trị cha"),
      dataIndex: "parentName",
      key: "parentName",
      width: 20,
    },
    {
      title: t("Ngày tạo", "Ngày tạo"),
      dataIndex: "createdDate",
      key: "createdDate",
      width: 10,
      render: (_: any, record, index: number) => {
        return record.createdDate ? formatDateV2(record.createdDate) : null;
      },
    },
    {
      title: t("Trạng thái", "Trạng thái"),
      dataIndex: "status",
      key: "status",
      render: (_: any, record: { status: boolean; id: number }) => {
        const handleChange = (checked: boolean) => {
          record.status = checked;
        };

        const confirm = (id: number) => {
          //   setLoading(true);
          //   changeStatusPortfolioValue({
          //     id: id,
          //     status: record?.status,
          //   })
          //     .then((res) => {
          //       if (res.status === 200) {
          //         setTimeout(() => {
          //           setLoading(false);
          //         }, 333);
          //         helpService.successMessage("Thay đổi trạng thái thành công!");
          //         getAllPortfolioValue();
          //       }
          //     })
          //     .catch((err) => {
          //       console.error(err);
          //     });
        };

        const cancel = () => {
          helpService.errorMessage(t("Hủy thao tác thành công!", "Hủy thao tác thành công!"));
        };

        return (
          <Popconfirm
            rootClassName="popconfirm-change-status"
            description={t("Xác nhận đổi trạng thái?", "Xác nhận đổi trạng thái?")}
            onConfirm={() => confirm(get(record, "id"))}
            onCancel={cancel}
            okText={t("Xác nhận", "Xác nhận")}
            cancelText={t("Huỷ", "Huỷ")}
            title=""
          >
            <Switch
              defaultChecked={record.status}
              checked={record.status}
              onChange={handleChange}
            />
          </Popconfirm>
        );
      },
      width: 10,
    },
    {
      title: "",
      dataIndex: "action",
      key: "operation",
      render: (_, record) => {
        const location = {
          id: `${record.id}`,
        };

        return (
          <>
            <Space>
              <a
                className="action-table"
                onClick={() =>
                  navigate(
                    `${routesConfig.portfolioValueManagementDetail}/${record?.id}`,
                    {
                      state: {
                        mode: "view",
                        record,
                        name: record.name,
                        idEdit: record?.id,
                      },
                    }
                  )
                }
              >
                <EyeOutlined />
              </a>

              <Dropdown
                menu={{
                  items: portfolioOptions,
                  onClick: ({ key }) => {
                    if (key === "1") {
                      getMoocPortfolioValueUpdate(record.id);
                      handleOpenEdit(record.id);
                    }
                    if (key === "2") {
                      Modal.confirm({
                        title: t("Xoá giá trị danh mục", "Xoá giá trị danh mục"),
                        content: t("Dữ liệu đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá?", "Dữ liệu đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá?"),
                        onOk: () => deletePortfolioValue(record.id),
                        centered: true,
                        okText: t("Xác nhận", "Xác nhận"),
                        cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
                        footer: (_, { OkBtn, CancelBtn }) => (
                          <>
                            <CancelBtn />
                            <OkBtn />
                          </>
                        ),
                      });
                    }
                  },
                }}
                placement="bottomRight"
              >
                <Button>
                  <MoreOutlined />
                </Button>
              </Dropdown>
            </Space>
          </>
        );
      },
      // fixed: "right",
      width: 10,
    },
  ];

  // Filter search
  const handleOpenFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const clearFilter = (form: FormInstance) => {
    form.resetFields();
    setFilterData({
      ...filterData,
      createdDateFrom: null,
      createdDateTo: null,
      status: null,
    });
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    setParams({ [name]: value });
    setSearchValue(value);
    if (value.length === 0) {
      setSearchValue("");
      setParams();
    }
  };

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      setPageNumber(1);
      getAllPortfolioValue();
    }
  };

  const handleSubmitSearch = () => {
    setPageNumber(1);
    getAllPortfolioValue();
  };

  const handleFinish = (values: any) => {
    setPageNumber(1);
    setFilterData({
      ...filterData,
      status: values.status,
      createdDateFrom: values?.time
        ? (values?.time[0]).add(1, "day").toISOString()
        : null,
      createdDateTo: values?.time
        ? (values?.time[1]).add(1, "day").toISOString()
        : null,
    });
  };

  // Get data portfolio value
  const getAllPortfolioValue = () => {
    setLoading(true);
    const dataReq = {
      page: pageNumber,
      size: pageSize,
      keyword: searchValue,
      status: filterData.status,
      portfolioId: filterData.portfolioId,
      createdDateFrom: filterData.createdDateFrom
        ? filterData.createdDateFrom
        : null,
      createdDateTo: filterData.createdDateTo ? filterData.createdDateTo : null,
      sort:
        isEmpty(fieldSortOrder) || isEmpty(statusOrder)
          ? ["created_date, desc"]
          : [`${fieldSortOrder},${statusOrder}`],
    };
    getAllValueByFilter(dataReq)
      .then((res) => {
        setDataPortfolioValue(res.data.data.moocPortfolioValueData);
        setDataOptions({
          ...dataOptions,
          dataPortfolioValue: res.data.data.moocPortfolioValueData,
        });
        setTotalRecords(res.data.data.total);
        setTimeout(() => {
          setLoading(false);
        }, 300);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  // Get portfolio value to edit
  const getMoocPortfolioValueUpdate = async (id: number) => {
    setLoadingForm(true);
    try {
      await getMoocPortfolioValueById(id).then((res) => {
        const { data } = res.data;
        setDataDetail(data);
        setTimeout(() => {
          setLoadingForm(false);
        }, 333);
      });
    } catch (err) {
      console.error(err);
    }
  };

  // Modal create | edit
  const handleOpenCreate = () => {
    setIsOpened(true);
  };

  const handleOpenEdit = (id: number) => {
    setEditId(id);
    setIsOpened(true);
    setIsOpenedEdit(true);
  };

  const handleClose = () => {
    setIsOpened(false);
    setIsOpenedEdit(false);
    form.resetFields();
  };

  const handleCreateAndEdit = () => {
    Modal.confirm({
      title: !isOpenedEdit
        ? t("Thêm mới giá trị danh mục", "Thêm mới giá trị danh mục")
        : t("Chỉnh sửa giá trị danh mục", "Chỉnh sửa giá trị danh mục"),
      content: t("Đảm bảo tất cả các thông tin liên quan đã được kiểm tra và cập nhật đầy đủ trước khi lưu", "Đảm bảo tất cả các thông tin liên quan đã được kiểm tra và cập nhật đầy đủ trước khi lưu"),
      onOk: () => form.submit(),
      centered: true,
      okText: t("Xác nhận", "Xác nhận"),
      cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
      footer: (_, { OkBtn, CancelBtn }) => (
        <>
          <CancelBtn />
          <OkBtn />
        </>
      ),
    });
  };

  const onFinishCreate = async (values: any) => {
    if (Object.keys(values).length > 0) {
      if (isOpenedEdit) {
        const dataPayload = {
          id: editId,
          name: values.name.trim(),
          code: values.code.trim(),
          parentId: values.cateDad,
          status: values.status,
          portfolioId: values.portfolioId,
        };
        setIsSaving(true);
        try {
          await updateMoocPortfolioValue(dataPayload).then((res) => {
            const { success } = res.data;
            if (success) {
              message.success(t("Cập nhật giá trị danh mục thành công!", "Cập nhật giá trị danh mục thành công!"));
            } else {
              message.error(t("Có lỗi xảy ra vui lòng thử lại!", "Có lỗi xảy ra vui lòng thử lại!"));
            }
            handleClose();
            getAllPortfolioValue();
          });
        } catch (err) {
          console.error(err);
        } finally {
          setIsSaving(false);
        }
      } else {
        const dataPayload = {
          name: values.name.trim(),
          code: values.code.trim(),
          parentId: values.cateDad,
          status: values.status,
          portfolioId: values.portfolioId,
        };
        setIsSaving(true);
        try {
          await addMoocPortfolioValue(dataPayload).then((res) => {
            const { success } = res.data;
            if (success) {
              message.success(t("Thêm mới giá trị danh mục thành công!", "Thêm mới giá trị danh mục thành công!"));
              setFilterData({
                ...filterData,
                createdDateFrom: null,
                createdDateTo: null,
                status: null,
              });
            } else {
              message.error(t("Có lỗi xảy ra vui lòng thử lại!", "Có lỗi xảy ra vui lòng thử lại!"));
            }
            handleClose();
            getAllPortfolioValue();
          });
        } catch (err) {
          console.error(err);
        } finally {
          setIsSaving(false);
        }
      }
    }
  };

  // Delete portfolio value
  const deletePortfolioValue = async (id: number) => {
    try {
      await deleteMoocPortfolioValue(id).then((res) => {
        if (res.status === 200) {
          message.success(t("Xóa giá trị danh mục thành công!", "Xóa giá trị danh mục thành công!"));
          getAllPortfolioValue();
        }
      });
    } catch (err) {
      console.error(err);
    }
  };

  // Import file Excel to add new
  const importExcel = async (file: any) => {
    setLoading(true);
    try {
      await importExcelMoocPortfolioValue(file).then((res) => {
        if (res.status === 200) {
          message.success(t("Thêm mới giá trị danh mục thành công!", "Thêm mới giá trị danh mục thành công!"));
          setLoading(false);
          setTimeout(() => {
            setLoading(false);
          }, 300);
          getAllPortfolioValue();
        }
      });
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  // Export file Excel
  const exportExcel = async () => {
    const dataReq = {
      page: pageNumber,
      size: pageSize,
      keyword: searchValue,
      status: filterData.status,
      portfolioId: filterData.portfolioId,
      createdDateFrom: filterData.createdDateFrom
        ? filterData.createdDateFrom
        : null,
      createdDateTo: filterData.createdDateTo ? filterData.createdDateTo : null,
      sort:
        isEmpty(fieldSortOrder) || isEmpty(statusOrder)
          ? ["created_date, desc"]
          : [`${fieldSortOrder},${statusOrder}`],
    };
    setIsRendering(true);
    try {
      await exportExcelMoocPortfolioValue(dataReq).then((res) => {
        const fileData = res.data;

        const blob = new Blob([fileData], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);

        downloadLink.download = `${t("Danh sách giá trị danh mục", "Danh sách giá trị danh mục")}.xlsx`;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        // message.success(t("Tải xuống thành công!", "Tải xuống thành công!"));
        setIsRendering(false);
      });
    } catch (err) {
      console.error("Error downloading Excel file:", err);
    }
  };

  // Download file template excel
  const handleDownloadFile = async () => {
    try {
      await downloadPortfolioValueTemplateFile().then((res) => {
        const fileData = res.data;

        const blob = new Blob([fileData], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);

        downloadLink.download = `${t("Mẫu thêm mới giá trị danh mục", "Mẫu thêm mới giá trị danh mục")}.xlsx`;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        // message.success(t("Tải xuống thành công!", "Tải xuống thành công!"));
      });
    } catch (err) {
      console.error("Error downloading Excel file:", err);
    }
  };

  // Sort
  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
        ? "desc"
        : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  // useEffect
  useEffect(() => {
    if(portfolioIdValue) {
      setFilterData({
        ...filterData,
        portfolioId: portfolioIdValue,
      })
    }
  }, [portfolioIdValue]);

  useEffect(() => {
    if (Object.keys(dataDetail).length > 0) {
      form.setFieldsValue({
        name: dataDetail.name,
        code: dataDetail.code,
        portfolioId: dataDetail.portfolio,
        cateDad: dataDetail.parentId ? dataDetail.parentId : null,
        status: dataDetail.status,
      });
    }
  }, [dataDetail]);

  useEffect(() => {
    const dataReqPortfolioValue = {
      page: pageNumber,
      size: pageSize,
      keyword: searchValue,
      status: filterData.status,
      createdDateFrom: filterData.createdDateFrom
        ? filterData.createdDateFrom
        : null,
      createdDateTo: filterData.createdDateTo ? filterData.createdDateTo : null,
      portfolioId: filterData.portfolioId ? filterData.portfolioId : null,
      sort:
        isEmpty(fieldSortOrder) || isEmpty(statusOrder)
          ? ["created_date, desc"]
          : [`${fieldSortOrder},${statusOrder}`],
    };
    setLoading(true);
    Promise.all([
      getAllValueByFilter(dataReqPortfolioValue),
      getAllPortfolioValueByName(""),
      getAllPortfolioByName(""),
    ])
      .then((res) => {
        const dataPortfolioValue = res[0].data.data.moocPortfolioValueData;
        const dataPortfolioValueByName = res[1].data.data;
        const dataPortfolio = res[2].data.data;
        const dataHasParentId = res[2].data?.data?.map((item: any) => {
          return {
            id: item.id,
            parentId: item.parentId,
          };
        });
        setDataPortfolioValue(dataPortfolioValue);
        setListDataPortfolio(dataPortfolio);
        setTotalRecords(res[0].data.data.total);
        setListPortfolioValueHasParentID(dataHasParentId);

        setDataOptions({
          ...dataOptions,
          dataPortfolioValue: dataPortfolioValueByName,
          dataPortfolio: dataPortfolio,
        });
        setTimeout(() => {
          setLoading(false);
        }, 300);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  }, [pageNumber, pageSize, filterData, statusOrder]);

  return (
    <Card className="card-major" bordered={false}>
      <Form.Provider
        onFormFinish={(name, { values, forms }) => {
          if (name === "createPortfolioValue") {
            const { createPortfolioValue } = forms;
            const data =
              createPortfolioValue.getFieldsValue(validateFieldCreate);
            onFinishCreate(data);
          }
        }}
      >
        <div
          className={`page-header-group--layout ${
            showFilter ? "open-filter" : ""
          }`}
        >
          <div className="table-header--wrapper">
            <div className="table-header--left">
              <PageHeader title={title} />
            </div>
            <FilterTable
              handleOpen={handleOpenCreate}
              searchValue={searchValue}
              handleOpenFilter={handleOpenFilter}
              handleSubmitSearch={handleSubmitSearch}
              handleSearch={handleSearch}
              handleChangeInput={handleChangeInput}
              exportExcel={exportExcel}
              handleDownloadFile={handleDownloadFile}
              importExcel={importExcel}
              isRendering={isRendering}
            />
          </div>
          <FormFilter
            clearFilter={clearFilter}
            dataOptions={dataOptions}
            onFinish={handleFinish}
            showFilter={showFilter}
          />
        </div>
        <TableData
          dataTable={dataPortfolioValue}
          dataColumns={dataColumns}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          pageNumber={pageNumber}
          pageSize={pageSize}
          loadingTable={loading}
          pagination={true}
          scroll={{ x: 900, y: 600 }}
          totalRecords={totalRecords}
          handleTableChangeProps={handleTableChange}
        />
        <DrawerCustom
          title={
            isOpenedEdit
              ? t("Chỉnh sửa giá trị danh mục", "Chỉnh sửa giá trị danh mục")
              : t("Thêm mới giá trị danh mục", "Thêm mới giá trị danh mục")
          }
          open={isOpened}
          onClose={handleClose}
          extraNode={
            <Space>
              <Button onClick={handleClose} className="btn btn-outlined">
                <CloseOutlined />
                <Typography.Text>{t("Hủy", "Hủy")}</Typography.Text>
              </Button>
              <Button
                className="btn btn-primary"
                htmlType="submit"
                onClick={handleCreateAndEdit}
                disabled={isSaving}
              >
                {isSaving ? <LoadingOutlined /> : <SaveOutlined />}
                <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
              </Button>
            </Space>
          }
          widthDrawer={690}
        >
          <FormCreatePortfolioValue
            form={form}
            dataOptions={dataOptions}
            listPortfolioValueHasParentID={listPortfolioValueHasParentID}
            loadingForm={loadingForm}
          />
        </DrawerCustom>
      </Form.Provider>
    </Card>
  );
};

export default CardPortfolioValue;
